import React from 'react';

import { Box, Text } from 'Components/Base';
import { getAppUIVariantConfig } from 'Util/uiVariantSet';

const CourseBannerTitle = ({ title, subTitle, ...props }) => {
  const { MyCourseTitle } = getAppUIVariantConfig();
  switch (MyCourseTitle) {
    case 'Dark': {
      return (
        <Box {...props}>
          {title && (
            <Text textStyle={'heading4'} color={'text'} lineHeight={'normal'}>
              {title}
            </Text>
          )}
          <Text textStyle={'subtitle1'} color={'text'} mt={3} lineHeight={'normal'}>
            {subTitle}
          </Text>
        </Box>
      );
    }
    case 'Light': {
      return (
        <Box {...props}>
          {title && (
            <Text textStyle={'heading4'} color={'white'} lineHeight={'normal'}>
              {title}
            </Text>
          )}
          <Text textStyle={'subtitle1'} color={'white'} mt={3} lineHeight={'normal'}>
            {subTitle}
          </Text>
        </Box>
      );
    }
    default: {
      return (
        <Box {...props}>
          {title && (
            <Text textStyle={'heading2'} color={'white'} px={4}>
              {title}
            </Text>
          )}
          <Text textStyle={'heading4'} color={'white'} px={4} mb={4} mt={7}>
            {subTitle}
          </Text>
        </Box>
      );
    }
  }
};

export default CourseBannerTitle;
